import store from "./store";
import { EventBus } from "./store/modules/eventbus";
import {
  GLOBAL_EVENT_CREATE_LEAVE_WARNING,
  GLOBAL_EVENT_PERMISSION_DENIED,
} from "Consts/globalEvents";
import { permissions } from "Consts/permissions";
import {
  ROUTE_USER_MODULES_JOIN,
  ROUTE_USER_MODULES_MY,
  ROUTE_EXPERT_PROVIDER_MODULES_LIBRARY,
  ROUTE_EXPERT_PROVIDER_MODULES_MY,
  ROUTE_EXPERT_PROVIDER_MODULES_OTHER,
  ROUTE_GROUP_DETAILS,
  ROUTE_LOGIN,
  ROUTE_MODULES_INDEX,
  ROUTE_PROFILE_ONBOARDING,
  ROUTE_RESET_PASSWORD,
  ROUTE_RESET_PASSWORD_SUBMIT,
  SETTINGS_ADD_CONNECTION_ROUTE,
  SETTINGS_PERMISSIONS_ROUTE,
  SETTINGS_PERMISSIONS_USER_LIST_ROUTE,
  ROUTE_REWARD_DETAILS,
  ROUTE_NEW_EMAIL_VERIFICATION,
  ROUTE_INDEX,
  ROUTE_NEW_PASSWORD_VERIFICATION,
  ROUTE_CATEGORIES_MANAGEMENT,
  ROUTE_CATEGORY_CREATE,
  ROUTE_CATEGORY_EDIT,
  ROUTE_SUBCATEGORIES_CREATE,
  ROUTE_SUBCATEGORY_EDIT,
  ROUTE_GROUP_MEMBERS,
  ROUTE_GROUP_MODULES,
  ROUTE_SOCIAL_MESSAGES,
  ROUTE_SOCIAL_GROUPS,
  ROUTE_MODULE_GROUP_JOIN,
  ROUTE_MODULE_LEADERBOARDS,
  ROUTE_SOCIAL_EXPERTS,
  ROUTE_SOCIAL_FRIENDS,
  ROUTE_SOCIAL_USERS,
  ROUTE_EXPERT_REQUESTS,
  ROUTE_MODULE_JOIN_REQUESTS,
  ROUTE_USER_REQUESTS,
  ROUTE_MANAGE_EXPERT_CONNECTIONS,
  ROUTE_SOCIAL_FRIENDS_OF_USERS,
  ROUTE_SOCIAL_FRIENDS_OF_FRIENDS,
  ROUTE_TRAQING_EXPERT_PROVIDER,
  ROUTE_REWARDS_LEADERBOARD,
  ROUTE_REWARDS_POTENTIAL,
  ROUTE_REWARDS_WON,
  ROUTE_SOCIAL_EXPERTS_INVITES,
  ROUTE_SOCIAL_EXPERTS_ACCESS_REQUESTS,
  ROUTE_EXPERT_PROVIDER_MODULES_TEMPLATES,
  ROUTE_PROFILE_MY_USERS_LIST,
  ROUTE_MASTER_LOGIN,
  ROUTE_ARCHIVE_INDEX,
  SETTINGS_GENERAL_ROUTE,
  ROUTE_MODULE_USER_LIST_USERS,
  ROUTE_MODULE_USER_LIST_APPROVERS,
  ROUTE_MODULE_USER_LIST_EXPERTS,
  ROUTE_MODULE_USER_LIST_PARTICIPANTS,
  ROUTE_MODULE_USER_LIST_GROUPS,
  ROUTE_TRAQ_USER_LIST_USERS,
  ROUTE_TRAQ_USER_LIST_PARTICIPANTS,
  ROUTE_TRAQ_USER_LIST_EXPERTS,
  ROUTE_TRAQ_USER_LIST_APPROVERS,
  ROUTE_CONFIRM_TWO_FACTOR_DISABLE,
  ROUTE_CONFIRM_TWO_FACTOR_ENABLE,
  ROUTE_USERNAME_CHANGE_VERIFY,
  ROUTE_RECOVER_USERNAME,
  ROUTE_RECOVER_USERNAME_REVEAL,
  SETTINGS_CONNECTIONS_ROUTE,
  SETTINGS_EXPERT_CONNECTIONS_ROUTE,
  ROUTE_APPROVE_STEPS_NAME,
  ROUTE_APPROVE_MODULES_NAME,
  ROUTE_PROTECTED_FILE_DOWNLOAD,
  ROUTE_ACCOUNTS_LIST,
  ROUTE_ACCOUNT_DETAILS,
  ROUTE_TRAQING_USER_REPORT,
  ROUTE_STEP_UNDO_REQUESTS,
  ROUTE_MEDIA_STORAGE,
  ROUTE_QR_CODE_SETTINGS,
  ROUTE_QR_CODE_DO_STEP_CONFIRMATION,
  ROUTE_MODULE_QR_CODE_JOIN_CONFIRM,
  ROUTE_TRAQ_QR_CODE_JOIN_CONFIRM,
  ROUTE_CONTENT_REPORT_LIST,
  ROUTE_STEP_TEMPLATE_CREATE,
  ROUTE_STEP_TEMPLATE_LIBRARY,
} from "Consts/publicRoutes";
import { UserRoles } from "Consts/user";
import { moduleLibraryTabs } from "Modules/challenges/constants/moduleLibraryTabs";
import { appRoutes } from "Public/consts/appRoutes";
import { AUTH_USER_GET } from "Public/store/modules/auth";
import { checkPermission } from "Public/store/utils/checkPermission";
import { checkUserRolePermission } from "Public/store/utils/checkUserRolePermission";
import { checkUserStoreReady } from "Public/store/utils/checkUserStoreReady";
import EmailVerification from "Public/views/Authorization/EmailVerification/EmailVerification";
import { isTraqify } from "Shared/helpers/isTraqify";
import { LAYOUT_AUTH, UI_LAYOUT_SET } from "Shared/store/ui";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// bring in pages
const ModuleUserList = () => import("./views/Challenges/UserList");
const StepDetails = () => import("Modules/steps/pages/StepDetails");
const GroupJoinModule = () => import("./views/Challenges/GroupJoinModule");
const Signup = () => import("Views/Authorization/SignUp");
const VerificationRetry = () =>
  import("./views/Authorization/VerificationRetry/VerificationRetry");

const VerificationSent = () =>
  import("./views/Authorization/VerificationSent/VerificationSent");

const Login = () => import("./views/Authorization/Login");
const Logout = () => import("./views/Authorization/Logout");
const ResetPassword = () =>
  import("Modules/authorization/pages/ResetPassword/index.vue");

const ResetPasswordRequest = () =>
  import("Modules/authorization/pages/ResetPasswordRequest/index.vue");

const ActivityLog = () => import("Views/ActivityLogs");
const CoursesCreate = () => import("./views/Challenges/Create/Index");
const CoursesIndex = () => import("./views/Challenges/Index/Index");
const ClientIndex = () => import("Views/Challenges/Index/ClientIndex");
const ExpertProviderIndex = () =>
  import("./views/Challenges/Index/ExpertProviderIndex");

const CoursesShow = () => import("./views/Challenges/Show/Index");
const CourseLeaderboard = () => import("./views/Challenges/Leaderboard/Index");

const CourseInviteParticipants = () =>
  import("./views/Challenges/InviteParticipants/ChallengeInviteParticipants");

const Chat = () => import("./views/Social/Chat/Index");
const Error404 = () => import("Shared/components/Error404");
const ProfileOnboarding = () =>
  import("./views/Profile/Onboarding/OnboardingProfile");

const Profile = () => import("Views/Profile/Show");
const ProfileModuleList = () => import("./views/Profile/Show/ModuleList");
const ProfileMyUsersList = () => import("./views/Profile/MyUsersList");
const TraqShow = () => import("./views/Traqs/Show/Index");
const TraqCreate = () => import("./views/Traqs/Create/Index");
const TraqInviteParticipants = () =>
  import("./views/Traqs/Show/TraqInviteParticipants");

const TraqUserList = () => import("./views/Traqs/UserList");
const Report = () => import("./views/Traqing/Report/Report");
const SocialIndex = () => import("./views/Social/Index");
const SocialFriendRequests = () =>
  import("./views/Social/FriendRequests/Index");

const SocialClientRequests = () => import("./views/Social/ClientRequests");
const ModuleJoinRequests = () => import("./views/Social/ModuleJoinRequests");
const SocialFriendsOfFriends = () =>
  import("./views/Social/FriendsOfFriends/Index");

const SocialGroupRequests = () =>
  import("./views/Social/Groups/GroupRequests/Index");

const SocialModuleRequests = () =>
  import("./views/Social/Groups/ModuleRequests/ModuleRequests");

const SocialNotifications = () => import("./views/Social/Notifications");
const SocialExpertRequests = () => import("./views/Social/ExpertRequests");
const SocialExpertsInvites = () => import("./views/Social/ModuleInvites");
const SocialExpertsAccessRequests = () =>
  import("./views/Social/DataAccessRequests");

const RewardsIndex = () => import("./views/Rewards/Index/RewardsIndex");
const RewardShow = () => import("./views/Rewards/Show/RewardShow");
const GroupCreate = () => import("./views/Groups/Create/GroupCreate");
const Onboarding = () => import("./views/Onboarding/Onboarding");
const GroupShow = () => import("./views/Groups/Show/GroupShow");
const GroupMemberManagement = () => import("Views/Groups/MemberManagement");
const GroupModuleManagement = () =>
  import("./views/Groups/ModuleManagement/ModuleManagement");

const TraqingIndex = () => import("./views/Traqing/TraqingIndex");
const ExpertProviderReports = () =>
  import("./views/Traqing/ExpertProviderReports");

const ProviderPermissions = () =>
  import("./views/Settings/Permissions/Permissions");

const PermissionsUserList = () =>
  import("./views/Settings/Permissions/components/UserList");

const Connections = () => import("./views/Settings/Connections/Connections");
const ExpertConnections = () =>
  import("./views/Settings/Connections/ExpertConnections");
const AddConnection = () =>
  import("./views/Settings/Connections/ProviderConnections/AddConnection");

const ExpertModuleConnections = () =>
  import("./views/Settings/Connections/ExpertModuleConnections");

const ApproveIndex = () => import("./views/Approve/index");
const ApproveContent = () => import("./views/Approve/ApproveContent");
const NewEmailVerification = () =>
  import("./views/Authorization/NewEmailVerification");

const NewPasswordVerification = () =>
  import("./views/Authorization/NewPasswordVerification");

const MasterLogin = () => import("./views/Authorization/MasterLogin");
const Messages = () => import("Views/Social/Messages");
const SettingsGeneral = () => import("Views/Settings/General");
const TwoFactorToggleConfirmation = () =>
  import("Views/Authorization/TwoFactorToggleConfirmation");
const CategoriesManagement = () => import("Views/Tags/Management");
const CategoryCreate = () => import("Views/Tags/Create");
const SubcategoryCreate = () => import("Views/Tags/Subtag/Create");
const ModuleOverview = () => import("Views/Challenges/Overview");

const UsernameChangeVerify = () =>
  import("Views/Authorization/UsernameChangeVerify");

const RecoverUsername = () => import("Views/Authorization/RecoverUsername");
const RecoverUsernameReveal = () =>
  import("Views/Authorization/RecoverUsernameReveal");
const ExpertProviderNotes = () => import("Views/Traqing/Notes");

const ProtectedFileDownload = () =>
  import("Views/Traqing/ProtectedFileDownload");
const AccountsList = () => import("Modules/accounts/pages/AccountList");
const AccountDetails = () => import("Modules/accounts/pages/AccountDetails");

const StepUndoRequestList = () =>
  import("Modules/steps/pages/StepUndoRequests");

const MediaStorage = () => import("Modules/files/pages/MediaStorage");
const QRCodeSettings = () => import("Modules/qrCodes/pages/QRCodeSettings");

const QRCodeDoStepConfirmation = () =>
  import("Modules/qrCodes/pages/QRCodeDoStepConfirmation");

const QRCodeJoinModule = () =>
  import("Modules/qrCodes/pages/QRCodeJoinModuleConfirmation");

const QRCodeJoinTraq = () =>
  import("Modules/qrCodes/pages/QRCodeJoinTraqConfirmation");

const ContentReportList = () =>
  import("Modules/contentReport/pages/ContentReportList");

const StepTemplateCreate = () =>
  import("Modules/steps/pages/StepTemplateCreate");

// setup routes

const customRouteGuard =
  (permissions = [], roles = []) =>
  (to, from, next) => {
    checkUserStoreReady().then(() => {
      const permissionPassed =
        !!permissions.length &&
        !permissions
          .map((permission) => {
            return checkPermission(permission);
          })
          .includes(false);
      const rolesPassed = checkUserRolePermission(roles);
      const hasAccess = permissionPassed || rolesPassed;
      routeGuard(to, from, next, hasAccess);
    });
  };

const routeGuard = (to, from, next, hasAccess) => {
  if (hasAccess) next();
  else {
    EventBus.$root.$emit(GLOBAL_EVENT_PERMISSION_DENIED);
    next(from);
  }
};

let routes = [
  {
    name: ROUTE_USERNAME_CHANGE_VERIFY,
    path: appRoutes.usernameChangeVerify,
    component: UsernameChangeVerify,
    meta: {
      sectionTitle: "Username change verification",
      mobileTitle: "Username change verification",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: ROUTE_CONFIRM_TWO_FACTOR_ENABLE,
    path: appRoutes.confirmTwoFactorEnable,
    component: TwoFactorToggleConfirmation,
    props: { enableTwoFactor: true },
    meta: {
      sectionTitle: "Enable 2FA",
      mobileTitle: "Enable 2FA",
      layout: LAYOUT_AUTH,
    },
  },
  {
    name: ROUTE_CONFIRM_TWO_FACTOR_DISABLE,
    path: appRoutes.confirmTwoFactorDisable,
    component: TwoFactorToggleConfirmation,
    props: { enableTwoFactor: false },
    meta: {
      sectionTitle: "Disable 2FA",
      mobileTitle: "Disable 2FA",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: ROUTE_MASTER_LOGIN,
    path: appRoutes.masterLogin,
    component: MasterLogin,
    meta: {
      sectionTitle: "Master login",
      mobileTitle: "Master login",
      layout: LAYOUT_AUTH,
    },
    beforeEnter: customRouteGuard([], [UserRoles.master]),
  },

  {
    name: ROUTE_LOGIN,
    path: appRoutes.login,
    component: Login,
    props: true,
    meta: {
      sectionTitle: "Login",
      mobileTitle: "Login",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: ROUTE_RECOVER_USERNAME,
    path: appRoutes.recoverUsername,
    component: RecoverUsername,
    meta: {
      sectionTitle: "Username recovery",
      mobileTitle: "Username recovery",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: ROUTE_RECOVER_USERNAME_REVEAL,
    path: appRoutes.recoverUsernameReveal,
    component: RecoverUsernameReveal,
    meta: {
      sectionTitle: "Username recovery verify",
      mobileTitle: "Username recovery verify",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: "logout",
    path: "/logout",
    component: Logout,
    beforeEnter: customRouteGuard([permissions.system.logout]),
  },

  {
    name: "signup",
    path: "/register",
    component: Signup,
    meta: {
      sectionTitle: "Sign Up",
      mobileTitle: "Sign Up",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: "verification.sent",
    path: "/register/verification-sent",
    component: VerificationSent,
    props: true,
    meta: {
      sectionTitle: "Verification Sent",
      mobileTitle: "Verification Sent",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: "verification.complete",
    path: "/register/email-verification",
    component: EmailVerification,
    meta: {
      sectionTitle: "Sign Up Complete",
      mobileTitle: "Sign Up Complete",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: "verification.retry",
    path: "/register/verification-retry",
    component: VerificationRetry,
    props: true,
    meta: {
      sectionTitle: "Verification Retry",
      mobileTitle: "Verification Retry",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: ROUTE_RESET_PASSWORD_SUBMIT,
    path: appRoutes.resetPasswordRequest,
    component: ResetPasswordRequest,
    props: true,
    meta: {
      sectionTitle: "Reset Password",
      mobileTitle: "Reset Password",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: ROUTE_RESET_PASSWORD,
    path: appRoutes.resetPassword,
    component: ResetPassword,
    props: true,
    meta: {
      sectionTitle: "Reset Password",
      mobileTitle: "Reset Password",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: ROUTE_NEW_EMAIL_VERIFICATION,
    path: "/new-email-verify",
    component: NewEmailVerification,
    meta: {
      sectionTitle: "Confirm Email Change",
      mobileTitle: "Confirm Email Change",
      layout: LAYOUT_AUTH,
    },
  },

  {
    name: ROUTE_NEW_PASSWORD_VERIFICATION,
    path: "/new-password-confirm",
    component: NewPasswordVerification,
    meta: {
      sectionTitle: "Confirm Password Change",
      mobileTitle: "Confirm Password Change",
      layout: LAYOUT_AUTH,
    },
  },

  {
    path: "/",
    redirect: "/library",
    name: ROUTE_INDEX,
    // meta: { layout: LAYOUT_DEFAULT } // only needed if using something other than default
  },

  {
    path: appRoutes.activityLog,
    name: "activity.log",
    component: ActivityLog,
    props: true,
    meta: {
      sectionTitle: "Activity Log",
      mobileTitle: "Activity Log",
    },
  },

  {
    path: appRoutes.traqCreatePath,
    name: "traq.create",
    component: TraqCreate,
    props: true,
    meta: {
      sectionTitle: "Create Traq -",
      mobileTitle: "Description",
    },
    beforeEnter: customRouteGuard([permissions.traq.create]),
  },

  {
    path: appRoutes.traqDetailsPath,
    name: "traq.show",
    component: TraqShow,
    props: true,
    meta: {
      mobileTitle: "Traq Details",
      sectionTitle: "Traq Details",
    },
    beforeEnter: customRouteGuard([permissions.traq.get]),
  },

  {
    path: appRoutes.publicTraqDetailsPath,
    name: "traq.show.public",
    component: TraqShow,
    props: true,
    meta: {
      mobileTitle: "Traq Details",
      sectionTitle: "Traq Details",
    },
  },

  {
    path: appRoutes.traqInviteParticipantsPath,
    name: "traq.invite.participants",
    component: TraqInviteParticipants,
    props: true,
    meta: {
      sectionTitle: "Traq -",
      mobileTitle: "Invite Users",
    },
    beforeEnter: customRouteGuard([], [UserRoles.expert, UserRoles.provider]),
  },

  {
    path: appRoutes.traqUserListUsersPath,
    name: ROUTE_TRAQ_USER_LIST_USERS,
    component: TraqUserList,
    props: (route) => ({ ...route.params, tab: "users" }),
    meta: {
      sectionTitle: "Traq -",
      mobileTitle: "User List",
    },
    beforeEnter: customRouteGuard(
      [permissions.traq.members],
      [UserRoles.expert, UserRoles.provider]
    ),
  },
  {
    path: appRoutes.traqUserListParticipantsPath,
    name: ROUTE_TRAQ_USER_LIST_PARTICIPANTS,
    component: TraqUserList,
    props: (route) => ({ ...route.params, tab: "participants" }),
    meta: {
      sectionTitle: "Traq -",
      mobileTitle: "User List",
    },
    beforeEnter: customRouteGuard([permissions.traq.members], [UserRoles.user]),
  },
  {
    path: appRoutes.traqUserListExpertsPath,
    name: ROUTE_TRAQ_USER_LIST_EXPERTS,
    component: TraqUserList,
    props: (route) => ({ ...route.params, tab: "experts" }),
    meta: {
      sectionTitle: "Traq -",
      mobileTitle: "User List",
    },
    beforeEnter: customRouteGuard([permissions.traq.experts]),
  },
  {
    path: appRoutes.traqUserListApproversPath,
    name: ROUTE_TRAQ_USER_LIST_APPROVERS,
    component: TraqUserList,
    props: (route) => ({ ...route.params, tab: "approvers" }),
    meta: {
      sectionTitle: "Traq -",
      mobileTitle: "User List",
    },
    beforeEnter: customRouteGuard([permissions.traq.approvers]),
  },

  {
    path: appRoutes.library,
    name: ROUTE_MODULES_INDEX,
    component: CoursesIndex,
    props: true,
    meta: {
      sectionTitle: " ",
      mobileTitle: " ",
    },
  },

  {
    path: appRoutes.libraryMy,
    name: ROUTE_USER_MODULES_MY,
    component: ClientIndex,
    props: { default: true, tab: moduleLibraryTabs.my.value },
    meta: {
      sectionTitle: " ",
      mobileTitle: " ",
    },
    beforeEnter: customRouteGuard([permissions.module.join]),
  },

  {
    path: appRoutes.libraryJoin,
    name: ROUTE_USER_MODULES_JOIN,
    component: ClientIndex,
    props: { default: true, tab: "join" },
    meta: {
      sectionTitle: " ",
      mobileTitle: " ",
    },
    beforeEnter: customRouteGuard([permissions.module.join]),
  },

  {
    path: appRoutes.libraryMyExpertProvider,
    name: ROUTE_EXPERT_PROVIDER_MODULES_LIBRARY,
    component: ExpertProviderIndex,
    props: (route) => ({ ...route.params }),
    meta: {
      sectionTitle: " ",
      mobileTitle: " ",
    },
    beforeEnter: customRouteGuard(
      [],
      [UserRoles.expert, UserRoles.provider, UserRoles.approver]
    ),
  },

  {
    path: appRoutes.libraryCreatedByMe,
    name: ROUTE_EXPERT_PROVIDER_MODULES_MY,
    component: ExpertProviderIndex,
    props: { default: true, tab: moduleLibraryTabs.createdByMe.value },
    meta: {
      sectionTitle: " ",
      mobileTitle: " ",
    },
    beforeEnter: customRouteGuard([], [UserRoles.expert]),
  },

  {
    path: appRoutes.libraryCreatedByOthers,
    name: ROUTE_EXPERT_PROVIDER_MODULES_OTHER,
    component: ExpertProviderIndex,
    props: { default: true, tab: moduleLibraryTabs.createdByOthers.value },
    meta: {
      sectionTitle: " ",
      mobileTitle: " ",
    },
    beforeEnter: customRouteGuard([], [UserRoles.provider]),
  },

  {
    path: appRoutes.libraryTemplates,
    name: ROUTE_EXPERT_PROVIDER_MODULES_TEMPLATES,
    component: ExpertProviderIndex,
    props: { tab: moduleLibraryTabs.templates.value },
    meta: {
      sectionTitle: "",
      mobileTitle: "",
    },
    beforeEnter: customRouteGuard(
      [permissions.module.useTemplate],
      [UserRoles.template]
    ),
  },
  {
    path: appRoutes.libraryStepTemplates,
    name: ROUTE_STEP_TEMPLATE_LIBRARY,
    component: ExpertProviderIndex,
    props: { tab: moduleLibraryTabs.stepTemplates.value },
    meta: {
      sectionTitle: "",
      mobileTitle: "",
    },
    beforeEnter: customRouteGuard(
      [permissions.module.useTemplate],
      [UserRoles.template]
    ),
  },

  {
    path: appRoutes.libraryArchive,
    name: ROUTE_ARCHIVE_INDEX,
    component: ExpertProviderIndex,
    props: { tab: "archive" },
    meta: {
      sectionTitle: "",
      mobileTitle: "",
    },
    beforeEnter: customRouteGuard([permissions.module.archive]),
  },

  {
    path: appRoutes.moduleDetailsPath,
    name: "course.show",
    component: CoursesShow,
    props: true,
    meta: {
      sectionTitle: "Module Details",
      mobileTitle: "Module Details",
    },
    beforeEnter: customRouteGuard([permissions.module.get]),
  },

  {
    path: appRoutes.publicModuleDetailsPath,
    name: "course.show.public",
    component: CoursesShow,
    props: true,
    meta: {
      sectionTitle: "Module Details",
      mobileTitle: "Module Details",
    },
  },

  {
    path: appRoutes.moduleOverviewPath,
    name: "module.overview",
    component: ModuleOverview,
    props: true,
    meta: {
      sectionTitle: "Module overview",
      mobileTitle: "Module overview",
    },
    beforeEnter: customRouteGuard([], [UserRoles.expert, UserRoles.provider]),
  },

  {
    path: appRoutes.moduleInviteParticipantsPath,
    name: "challenges.invite.participants",
    component: CourseInviteParticipants,
    props: true,
    meta: {
      sectionTitle: "Module -",
      mobileTitle: "Invite Users",
    },
    beforeEnter: customRouteGuard([], [UserRoles.expert, UserRoles.provider]),
  },

  {
    path: appRoutes.moduleJoinAsGroupPath,
    name: ROUTE_MODULE_GROUP_JOIN,
    component: GroupJoinModule,
    props: true,
    meta: {
      sectionTitle: "Join Module as a Group",
      mobileTitle: "Join Module as a Group",
    },
  },

  {
    path: appRoutes.moduleLeaderboardPath,
    name: ROUTE_MODULE_LEADERBOARDS,
    component: CourseLeaderboard,
    props: true,
    meta: {
      sectionTitle: "Module Leaderboard",
      mobileTitle: "Module Leaderboard",
    },
  },

  {
    path: appRoutes.messages,
    name: ROUTE_SOCIAL_MESSAGES,
    component: Messages,
    props: true,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Messages",
    },
    beforeEnter: customRouteGuard([permissions.conversation.listing]),
  },

  {
    name: "social.messages.chat",
    path: "/social/messages/chat",
    component: Chat,
    props: true,
    meta: {
      sectionTitle: "Social - Messages",
      mobileTitle: "",
    },
    beforeEnter: customRouteGuard([permissions.conversation.listing]),
  },
  {
    name: "social.messages.chat.conversation",
    path: appRoutes.chatConversationPath,
    component: Chat,
    props: true,
    meta: {
      sectionTitle: "Social - Messages",
      mobileTitle: "",
    },
    beforeEnter: customRouteGuard([permissions.conversation.listing]),
  },

  {
    name: "course.create",
    path: appRoutes.moduleCreatePath,
    component: CoursesCreate,
    props: true,
    meta: {
      sectionTitle: "Create a Module -",
      mobileTitle: "Description",
    },
    beforeEnter: customRouteGuard([permissions.module.create]),
  },

  {
    path: appRoutes.moduleUserListUsersPath,
    name: ROUTE_MODULE_USER_LIST_USERS,
    component: ModuleUserList,
    props: (route) => ({ ...route.params, tab: "users" }),
    meta: {
      sectionTitle: "Module User List",
      mobileTitle: "Module User List",
    },
    beforeEnter: customRouteGuard(
      [permissions.module.members],
      [UserRoles.expert, UserRoles.provider]
    ),
  },
  {
    path: appRoutes.moduleUserListGroupsPath,
    name: ROUTE_MODULE_USER_LIST_GROUPS,
    component: ModuleUserList,
    props: (route) => ({ ...route.params, tab: "groups" }),
    meta: {
      sectionTitle: "Module User List",
      mobileTitle: "Module User List",
    },
    beforeEnter: customRouteGuard([permissions.module.groups]),
  },

  {
    path: appRoutes.moduleUserListApproversPath,
    name: ROUTE_MODULE_USER_LIST_APPROVERS,
    component: ModuleUserList,
    props: (route) => ({ ...route.params, tab: "approvers" }),
    meta: {
      sectionTitle: "Module User List",
      mobileTitle: "Module User List",
    },
    beforeEnter: customRouteGuard([permissions.module.approvers]),
  },
  {
    path: appRoutes.moduleUserListExpertsPath,
    name: ROUTE_MODULE_USER_LIST_EXPERTS,
    component: ModuleUserList,
    props: (route) => ({ ...route.params, tab: "experts" }),
    meta: {
      sectionTitle: "Module User List",
      mobileTitle: "Module User List",
    },
    beforeEnter: customRouteGuard([permissions.module.experts]),
  },
  {
    path: appRoutes.moduleUserListParticipantsPath,
    name: ROUTE_MODULE_USER_LIST_PARTICIPANTS,
    component: ModuleUserList,
    props: (route) => ({ ...route.params, tab: "participants" }),
    meta: {
      sectionTitle: "Module User List",
      mobileTitle: "Module User List",
    },
    beforeEnter: customRouteGuard(
      [permissions.module.members],
      [UserRoles.user]
    ),
  },

  {
    path: "/profile-onboarding",
    name: ROUTE_PROFILE_ONBOARDING,
    component: ProfileOnboarding,
    props: true,
    meta: {
      layout: LAYOUT_AUTH,
      sectionTitle: "Profile",
      mobileTitle: "Profile",
    },
  },

  {
    path: appRoutes.profilePath,
    name: "profile.show",
    component: Profile,
    props: true,
    meta: {
      sectionTitle: "My Profile",
      mobileTitle: "My Profile",
    },
  },

  {
    path: appRoutes.profileUserListPath,
    name: ROUTE_PROFILE_MY_USERS_LIST,
    component: ProfileMyUsersList,
    props: true,
    meta: {
      sectionTitle: "",
      mobileTitle: "",
    },
  },

  {
    path: "/profile-public/:id?",
    name: "profile.show.public",
    component: Profile,
    props: true,
  },
  {
    path: appRoutes.profileModuleListPath,
    name: "profile.show.module.type",
    component: ProfileModuleList,
    props: true,
    meta: {
      sectionTitle: "",
      mobileTitle: "",
    },
  },

  {
    path: "/profile-public/:id/:type",
    name: "profile.show.module.type.public",
    component: ProfileModuleList,
    props: true,
  },

  {
    path: appRoutes.stepDetailsPath,
    name: "steps.show",
    component: StepDetails,
    props: true,
    meta: {
      sectionTitle: "Step details",
      mobileTitle: "Step details",
    },
  },
  {
    path: appRoutes.stepTemplateDetails(":stepId"),
    name: "steps.show.template",
    component: StepDetails,
    props: true,
    meta: {
      sectionTitle: "Step template details",
      mobileTitle: "Step template details",
    },
  },
  {
    path: appRoutes.stepTemplateCreate,
    name: ROUTE_STEP_TEMPLATE_CREATE,
    component: StepTemplateCreate,
    meta: {
      sectionTitle: "Step template create",
      mobileTitle: "Step template create",
    },
    beforeEnter: customRouteGuard([], [UserRoles.template]),
  },

  {
    path: appRoutes.rewardsWon,
    name: ROUTE_REWARDS_WON,
    component: RewardsIndex,
    props: { default: true, tab: "won" },
    meta: {
      sectionTitle: "Rewards -",
      mobileTitle: "Won",
    },
    beforeEnter: customRouteGuard([], [UserRoles.user]),
  },
  {
    path: appRoutes.rewardsLeaderboard,
    name: ROUTE_REWARDS_LEADERBOARD,
    component: RewardsIndex,
    props: { default: true, tab: "leaderboard" },
    meta: {
      sectionTitle: "Rewards -",
      mobileTitle: "Leaderboard",
    },
    beforeEnter: customRouteGuard([], [UserRoles.user]),
  },
  {
    path: appRoutes.rewardsPotential,
    name: ROUTE_REWARDS_POTENTIAL,
    component: RewardsIndex,
    props: { default: true, tab: "potential" },
    meta: {
      sectionTitle: "Rewards -",
      mobileTitle: "Potential",
    },
    beforeEnter: customRouteGuard([], [UserRoles.user]),
  },

  {
    path: "/rewards",
    redirect: "/rewards/won",
  },

  {
    path: appRoutes.rewardDetailsPath,
    name: ROUTE_REWARD_DETAILS,
    component: RewardShow,
    props: true,
    meta: {
      sectionTitle: "Reward Details",
      mobileTitle: "Reward Details",
    },
  },

  {
    path: "/social",
    redirect: "/social/friends",
  },

  {
    path: appRoutes.friends,
    name: ROUTE_SOCIAL_FRIENDS,
    component: SocialIndex,
    props: { tab: "friends" },
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Friends",
    },
    beforeEnter: customRouteGuard([], [UserRoles.user]),
  },

  {
    path: appRoutes.users,
    name: ROUTE_SOCIAL_USERS,
    component: SocialIndex,
    props: { tab: "users" },
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Users",
    },
    beforeEnter: customRouteGuard([], [UserRoles.expert, UserRoles.provider]),
  },

  {
    path: appRoutes.groups,
    name: ROUTE_SOCIAL_GROUPS,
    component: SocialIndex,
    props: { tab: "groups" },
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Groups",
    },
    beforeEnter: customRouteGuard([permissions.group.listing]),
  },

  {
    path: appRoutes.experts,
    name: ROUTE_SOCIAL_EXPERTS,
    component: SocialIndex,
    props: { tab: "experts" },
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Experts",
    },
    beforeEnter: customRouteGuard([permissions.social.experts]),
  },

  {
    path: appRoutes.socialExpertInvites,
    name: ROUTE_SOCIAL_EXPERTS_INVITES,
    component: SocialExpertsInvites,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Module Invites",
    },
    beforeEnter: customRouteGuard([permissions.social.experts]),
  },

  {
    path: appRoutes.socialExpertAccessRequests,
    name: ROUTE_SOCIAL_EXPERTS_ACCESS_REQUESTS,
    component: SocialExpertsAccessRequests,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Data access requests",
    },
    beforeEnter: customRouteGuard([permissions.social.experts]),
  },

  {
    path: appRoutes.socialUserRequests,
    name: ROUTE_USER_REQUESTS,
    component: SocialClientRequests,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "User requests",
    },
    beforeEnter: customRouteGuard([], [UserRoles.expert, UserRoles.provider]),
  },

  {
    path: appRoutes.socialUserModuleJoinRequests,
    name: ROUTE_MODULE_JOIN_REQUESTS,
    component: ModuleJoinRequests,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Module join requests",
    },
    beforeEnter: customRouteGuard([], [UserRoles.expert, UserRoles.provider]),
  },

  {
    path: appRoutes.socialFriendRequests,
    name: "social.friend.requests",
    component: SocialFriendRequests,
    props: true,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Friend requests",
    },
    beforeEnter: customRouteGuard([], [UserRoles.user]),
  },

  {
    path: appRoutes.socialFriendsOfUsers,
    name: ROUTE_SOCIAL_FRIENDS_OF_USERS,
    props: { default: true, userType: "expert" },
    component: SocialFriendsOfFriends,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Friends of users",
    },
    beforeEnter: customRouteGuard([], [UserRoles.expert, UserRoles.provider]),
  },

  {
    path: appRoutes.socialFriendsOfFriends,
    name: ROUTE_SOCIAL_FRIENDS_OF_FRIENDS,
    component: SocialFriendsOfFriends,
    props: true,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Friends of friends",
    },
    beforeEnter: customRouteGuard([], [UserRoles.user]),
  },

  {
    path: appRoutes.socialGroupRequests,
    name: "social.group.requests",
    component: SocialGroupRequests,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Group requests",
    },
    beforeEnter: customRouteGuard([permissions.group.listing]),
  },

  {
    path: appRoutes.socialGroupModuleRequests,
    name: "social.group.module.requests",
    component: SocialModuleRequests,
    props: true,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Module requests",
    },
    beforeEnter: customRouteGuard([permissions.group.listing]),
  },

  {
    path: appRoutes.socialExpertRequests,
    name: ROUTE_EXPERT_REQUESTS,
    component: SocialExpertRequests,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Expert requests",
    },
    beforeEnter: customRouteGuard([permissions.social.experts]),
  },

  {
    path: appRoutes.groupCreate,
    name: "group.create",
    component: GroupCreate,
    props: true,
    meta: {
      sectionTitle: "Create a group -",
      mobileTitle: "Description",
    },
    beforeEnter: customRouteGuard([permissions.group.create]),
  },

  {
    path: appRoutes.onboarding,
    name: "onboarding",
    component: Onboarding,
    meta: {
      sectionTitle: "Onboarding",
      mobileTitle: "Onboarding",
      layout: LAYOUT_AUTH,
    },
  },

  // --------------------------- TRAQING USER ----------------------- //

  {
    path: appRoutes.traqingUserStatusPath,
    name: "traqing.status",
    component: TraqingIndex,
    props: (route) => ({ tab: "status", userId: route.params.userId }),
    meta: {
      sectionTitle: "Traqing -",
      mobileTitle: "My status",
    },
    beforeEnter: customRouteGuard(
      [permissions.reports.management],
      [UserRoles.user]
    ),
  },

  {
    path: appRoutes.traqingUserReportsPath,
    name: "traqs.reports",
    component: TraqingIndex,
    props: (route) => ({ tab: "reports", userId: route.params.userId }),
    meta: {
      sectionTitle: "Traqing -",
      mobileTitle: "My reports",
    },
    beforeEnter: customRouteGuard([permissions.reports.userReports]),
  },

  {
    path: appRoutes.traqingReportPath,
    name: ROUTE_TRAQING_USER_REPORT,
    component: Report,
    props: true,
    meta: {
      sectionTitle: "Program report",
      mobileTitle: "Program report",
    },
    beforeEnter: customRouteGuard([permissions.reports.userReports]),
  },

  {
    path: appRoutes.traqingNotesPath,
    name: "traqing.notes",
    component: TraqingIndex,
    props: (route) => ({ tab: "notes", userId: route.params.userId }),
    meta: {
      sectionTitle: "Traqing -",
      mobileTitle: "Notes library",
    },
    beforeEnter: customRouteGuard([permissions.reports.userReports]),
  },

  // ---------------------- PROVIDER\EXPERT TRAQING ----------------- //

  {
    path: "/traqing",
    name: ROUTE_TRAQING_EXPERT_PROVIDER,
    component: ExpertProviderReports,
    meta: {
      sectionTitle: "Traqing",
      mobileTitle: "Traqing",
    },
    beforeEnter: customRouteGuard([
      permissions.reports.management,
      permissions.reports.userReports,
    ]),
  },

  {
    path: appRoutes.providerExpertNotes,
    name: "providerExpertNotes",
    component: ExpertProviderNotes,
    meta: {
      sectionTitle: "Notes library",
      mobileTitle: "Notes library",
    },
    beforeEnter: customRouteGuard([
      permissions.reports.management,
      permissions.reports.userReports,
    ]),
  },

  // --------------------- SOCIAL GROUPS ---------------------- //

  {
    path: appRoutes.groupDetailsPath,
    name: ROUTE_GROUP_DETAILS,
    component: GroupShow,
    props: true,
    meta: {
      sectionTitle: "Group Details",
      mobileTitle: "Group Details",
    },
  },

  {
    path: appRoutes.groupMemberManagementPath,
    name: ROUTE_GROUP_MEMBERS,
    component: GroupMemberManagement,
    props: true,
    meta: {
      sectionTitle: "Group Details -",
      mobileTitle: "Member Management",
    },
    beforeEnter: customRouteGuard([permissions.group.manageMembers]),
  },

  {
    path: appRoutes.groupModuleManagementPath,
    name: ROUTE_GROUP_MODULES,
    component: GroupModuleManagement,
    props: true,
    meta: {
      sectionTitle: "Group Details -",
      mobileTitle: "Module Management",
    },
  },

  // -------------------------------------------------- //

  {
    path: appRoutes.notifications,
    name: "social.notifications",
    component: SocialNotifications,
    props: true,
    meta: {
      sectionTitle: "Social -",
      mobileTitle: "Notifications",
    },
    beforeEnter: customRouteGuard([permissions.notification.listing]),
  },

  {
    path: appRoutes.settingsGeneral,
    name: SETTINGS_GENERAL_ROUTE,
    component: SettingsGeneral,
    meta: {
      sectionTitle: "Settings -",
      mobileTitle: "General",
    },
    beforeEnter: customRouteGuard([permissions.user.accessGeneralSettings]),
  },

  {
    path: appRoutes.settingsPermissions,
    name: SETTINGS_PERMISSIONS_ROUTE,
    component: ProviderPermissions,
    props: true,
    meta: {
      sectionTitle: "Settings -",
      mobileTitle: "Permissions",
    },
    beforeEnter: customRouteGuard([], [UserRoles.expert, UserRoles.provider]),
  },

  {
    path: appRoutes.settingsUserListPath,
    name: SETTINGS_PERMISSIONS_USER_LIST_ROUTE,
    component: PermissionsUserList,
    props: true,
    meta: {
      sectionTitle: "Settings -",
      mobileTitle: "User List",
    },
    beforeEnter: customRouteGuard([], [UserRoles.expert, UserRoles.provider]),
  },

  {
    path: appRoutes.settingsConnectionsTab(":tab?"),
    name: SETTINGS_CONNECTIONS_ROUTE,
    component: Connections,
    props: true,
    meta: {
      sectionTitle: "Settings -",
      mobileTitle: "Connections",
    },
    beforeEnter: customRouteGuard([], [UserRoles.user, UserRoles.provider]),
  },

  {
    path: appRoutes.settingsExpertConnections,
    name: SETTINGS_EXPERT_CONNECTIONS_ROUTE,
    component: ExpertConnections,
    meta: {
      sectionTitle: "Settings -",
      mobileTitle: "Connections",
    },
    beforeEnter: customRouteGuard([], [UserRoles.expert]),
  },

  {
    path: "/settings/add-connection/:id",
    name: SETTINGS_ADD_CONNECTION_ROUTE,
    component: AddConnection,
    props: true,
    meta: {
      sectionTitle: "Settings -",
      mobileTitle: "Add Connection",
    },
    beforeEnter: customRouteGuard([], [UserRoles.provider]),
  },

  {
    path: appRoutes.settingsManageExpertModuleConnectionsPath,
    name: ROUTE_MANAGE_EXPERT_CONNECTIONS,
    component: ExpertModuleConnections,
    props: true,
    meta: {
      sectionTitle: "Settings -",
      mobileTitle: "Connections",
    },
    beforeEnter: customRouteGuard([], [UserRoles.provider, UserRoles.expert]),
  },

  {
    path: appRoutes.approveUsers,
    name: "approve.users",
    component: ApproveIndex,
    props: { tab: "users" },
    meta: {
      sectionTitle: "To do -",
      mobileTitle: "Users",
    },
    beforeEnter: customRouteGuard([permissions.approve.users]),
  },

  {
    path: appRoutes.approveGroups,
    name: "approve.groups",
    component: ApproveIndex,
    props: { tab: "groups" },
    meta: {
      sectionTitle: "To do -",
      mobileTitle: "Groups",
    },
    beforeEnter: customRouteGuard([permissions.approve.groups]),
  },

  {
    path: appRoutes.approveModules,
    name: ROUTE_APPROVE_MODULES_NAME,
    component: ApproveIndex,
    props: (route) => ({ tab: "modules", search: route.params.search }),
    meta: {
      sectionTitle: "To do -",
      mobileTitle: "Modules",
    },
    beforeEnter: customRouteGuard([permissions.approve.modules]),
  },

  {
    path: appRoutes.approveSteps,
    name: ROUTE_APPROVE_STEPS_NAME,
    component: ApproveContent,
    props: (route) => ({ tab: "steps", search: route.params.search }),
    meta: {
      sectionTitle: "To do -",
      mobileTitle: "Steps",
    },
    beforeEnter: customRouteGuard([permissions.approve.steps]),
  },

  {
    path: appRoutes.contentReports,
    name: ROUTE_CONTENT_REPORT_LIST,
    component: ContentReportList,
    meta: {
      sectionTitle: "To do -",
      mobileTitle: "Content reports",
    },
    beforeEnter: customRouteGuard([permissions.contentReport.review]),
  },

  {
    path: appRoutes.tagsManagement,
    name: ROUTE_CATEGORIES_MANAGEMENT,
    component: CategoriesManagement,
    meta: {
      sectionTitle: "Tags",
      mobileTitle: "Tags",
    },
    beforeEnter: customRouteGuard([], [UserRoles.provider, UserRoles.template]),
  },

  {
    path: appRoutes.tagCreate,
    name: ROUTE_CATEGORY_CREATE,
    component: CategoryCreate,
    meta: {
      sectionTitle: "Create a tag",
      mobileTitle: "Create a tag",
    },
    beforeEnter: customRouteGuard([permissions.tags.create]),
  },

  {
    path: appRoutes.tagEditPath,
    name: ROUTE_CATEGORY_EDIT,
    component: CategoryCreate,
    props: true,
    meta: {
      sectionTitle: "Edit the tag",
      mobileTitle: "Edit the tag",
    },
    beforeEnter: customRouteGuard([permissions.tags.update]),
  },

  {
    path: appRoutes.subTagCreatePath,
    name: ROUTE_SUBCATEGORIES_CREATE,
    component: SubcategoryCreate,
    props: true,
    meta: {
      sectionTitle: "Create subtag",
      mobileTitle: "Create subtag",
    },
    beforeEnter: customRouteGuard([permissions.subTags.create]),
  },

  {
    path: appRoutes.subTagEditPath,
    name: ROUTE_SUBCATEGORY_EDIT,
    component: SubcategoryCreate,
    props: true,
    meta: {
      sectionTitle: "Edit subtag",
      mobileTitle: "Edit subtag",
    },
    beforeEnter: customRouteGuard([permissions.subTags.update]),
  },
  {
    path: appRoutes.protectedFileDownloadPath,
    name: ROUTE_PROTECTED_FILE_DOWNLOAD,
    component: ProtectedFileDownload,
    props: true,
    meta: {
      sectionTitle: "Protected file download",
      mobileTitle: "Protected file download",
    },
  },

  {
    path: appRoutes.accountList,
    name: ROUTE_ACCOUNTS_LIST,
    component: AccountsList,
    props: true,
    meta: {
      sectionTitle: "Accounts list",
      mobileTitle: "Accounts list",
    },
    beforeEnter: customRouteGuard(
      [],
      [UserRoles.provider, UserRoles.providerAdmin]
    ),
  },

  {
    path: appRoutes.stepUndoRequestList,
    name: ROUTE_STEP_UNDO_REQUESTS,
    component: StepUndoRequestList,
    props: true,
    meta: {
      sectionTitle: "Undo step requests",
      mobileTitle: "Undo step requests",
    },
    beforeEnter: customRouteGuard(
      [],
      [UserRoles.provider, UserRoles.providerAdmin, UserRoles.expert]
    ),
  },

  {
    path: appRoutes.accountDetails(":id"),
    name: ROUTE_ACCOUNT_DETAILS,
    component: AccountDetails,
    props: true,
    meta: {
      sectionTitle: "Account details",
      mobileTitle: "Account details",
    },
    beforeEnter: customRouteGuard(
      [],
      [UserRoles.provider, UserRoles.providerAdmin]
    ),
  },

  // ---- MEDIA STORAGE -----

  {
    path: appRoutes.mediaStorage(":tab"),
    name: ROUTE_MEDIA_STORAGE,
    component: MediaStorage,
    props: true,
    meta: {
      sectionTitle: "Media storage",
      mobileTitle: "Media storage",
    },
    beforeEnter: customRouteGuard(
      [],
      [UserRoles.expert, UserRoles.provider, UserRoles.providerAdmin]
    ),
  },

  // ---- QR CODES ----
  {
    path: appRoutes.qrCodeSettings(":tab"),
    name: ROUTE_QR_CODE_SETTINGS,
    component: QRCodeSettings,
    props: true,
    meta: {
      sectionTitle: "QR code settings",
      mobileTitle: "QR code settings",
    },
    beforeEnter: customRouteGuard(
      [],
      [UserRoles.provider, UserRoles.providerAdmin]
    ),
  },

  {
    path: appRoutes.qrCodeDoStepConfirmation(":challengeId", ":id"),
    name: ROUTE_QR_CODE_DO_STEP_CONFIRMATION,
    component: QRCodeDoStepConfirmation,
    props: true,
    meta: {
      sectionTitle: "Step confirmation by QR code",
      mobileTitle: "Step confirmation by QR code",
    },
    beforeEnter: customRouteGuard([], [UserRoles.user]),
  },

  {
    path: appRoutes.moduleQRCodeJoin(":id"),
    name: ROUTE_MODULE_QR_CODE_JOIN_CONFIRM,
    component: QRCodeJoinModule,
    props: true,
    meta: {
      sectionTitle: "Module QR code join confirmation",
      mobileTitle: "Module QR code join confirmation",
    },
    beforeEnter: customRouteGuard([], [UserRoles.user]),
  },

  {
    path: appRoutes.traqQRCodeJoin(":id"),
    name: ROUTE_TRAQ_QR_CODE_JOIN_CONFIRM,
    component: QRCodeJoinTraq,
    props: true,
    meta: {
      sectionTitle: "Traq QR code join confirmation",
      mobileTitle: "Traq QR code join confirmation",
    },
    beforeEnter: customRouteGuard([], [UserRoles.user]),
  },

  {
    path: "*",
    component: Error404,
    name: "error",
    meta: { sectionTitle: "Page not Found", mobileTitle: "Page not Found" },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
});

const restrictMaster = (to, from, next) => {
  checkUserStoreReady().then(() => {
    const user = store.getters[AUTH_USER_GET];
    const { path } = to;
    const allowedPaths = [
      appRoutes.login,
      appRoutes.logout,
      appRoutes.library,
      appRoutes.masterLogin,
    ];
    if (user.isMaster && !allowedPaths.includes(path)) {
      next(appRoutes.masterLogin);
    }
  });
};

function bodyClass(route) {
  if (route && route.name) {
    return "page-container page-container-" + route.name.replace(".", "-");
  }
  return "page-container page-container-";
}

function requiresWarningModal(to, from) {
  const isCreatePage = from && from.name && from.name.includes(".create");
  return isCreatePage && to.name !== from.name && !to.params.pass;
}

function parseTabAppTitle() {
  if (isTraqify()) return "Traqify";
  return "Lifetraq";
}

router.beforeEach((to, from, next) => {
  EventBus.$emit("page-change", to);
  restrictMaster(to, from, next);
  const { sectionTitle, mobileTitle } = to.meta;
  const titleStart = parseTabAppTitle();
  document.title = `${titleStart} | ${
    sectionTitle === mobileTitle
      ? sectionTitle
      : `${sectionTitle} ${mobileTitle}`
  }`;
  to.meta.prevRoute = from;
  store.dispatch(UI_LAYOUT_SET, to.meta ? to.meta.layout : null);
  document.querySelector("body").className = bodyClass(to);
  if (requiresWarningModal(to, from)) {
    router.app.$root.$emit(GLOBAL_EVENT_CREATE_LEAVE_WARNING, to);
  } else {
    next();
  }
});

export default router;
